module.exports = __webpack_public_path__ + "static/img/hk.bdf19c7b.png";